import { l10nEnService } from '@uplift/services';
import * as Yup from 'yup';
import { AddressType, SexEnum } from '@uplift/types';
import { createDobFieldValidation, settingsAddressValidation } from '@uplift/ui-v2';
import { applyNameValidator, VALIDATION_HOME_PHONE, VALIDATION_MOBILE_PHONE } from '@uplift/validations';

export type AboutYouFormType = {
  firstName: string;
  preferredName?: string | null;
  middleName?: string;
  lastName: string;
  sex: SexEnum | null;
  pronouns?: string;
  dateOfBirth: string | null;
  address: AddressType;
  mobilePhone: string;
  homePhone?: string | null;
};

export const aboutYouValidation = (l10n: typeof l10nEnService): Yup.ObjectSchema<AboutYouFormType> =>
  Yup.object({
    firstName: applyNameValidator(Yup.string())
      .defined(l10n.validations.enterFirstName),
    preferredName: applyNameValidator(Yup.string())
      .nullable(),
    middleName: applyNameValidator(Yup.string())
      .notRequired(),
    lastName: applyNameValidator(Yup.string())
      .defined(l10n.validations.enterLastName),
    sex: Yup.mixed<SexEnum>().oneOf([ SexEnum.female, SexEnum.male ]).required(l10n.validations.sex),
    pronouns: Yup.string().notRequired().max(64, l10n.validations.lengthMatches(1, 64)),
    dateOfBirth: createDobFieldValidation(l10n, {
      adult: true,
      adultMsg: l10n.validations.dob.mustBe18ForBetterhelpPsychiatry,
    }),
    mobilePhone: VALIDATION_MOBILE_PHONE,
    homePhone: VALIDATION_HOME_PHONE,
    address: settingsAddressValidation(l10n),
  }) as Yup.ObjectSchema<AboutYouFormType>;
